import { ObjectMapper } from "json-object-mapper";
import { Model } from "../model";
import { IModel } from "../IModel";

export class WorkHealthClinicModel
    extends Model
    implements IModel<WorkHealthClinicModel> {
    companies: string[] = [];
    companyGroupId: string = "";
    name: string = "";
    email: string = "";
    contact: string = "";
    zipCode: string = "";
    state: string = "";
    city: string = "";
    district: string = "";
    address: string = "";
    number: string = "";
    complement: string = "";

    static create(input: any): WorkHealthClinicModel {
        return ObjectMapper.deserialize<WorkHealthClinicModel>(
            WorkHealthClinicModel,
            input
        );
    }
}
